import { arraySlice } from '@/app/utils/nativeArray';

import { useStore } from 'vuex';

export const useScrollData = () => {
  const store = useStore();

  //data
  const topPosition = ref(0);
  const cardHeight = ref(86);
  const rowsInOneFrame = ref(7);
  const perfectScrollbarOptions = reactive({
    minScrollbarLength: 20,
    wheelSpeed: 0.5,
  });

  const listData = computed(() => {
    const list = store.state.productPicker.query.length > 0 ? 'queryList' : 'list';
    return store.state.productPicker[list];
  });

  const wrapperStyle = computed(() => {
    return { height: `${maxHeight.value}px` };
  });

  const rowStyle = computed(() => {
    const style = {} as any;
    style.top = `${topPosition.value}px`;
    return style;
  });

  const maxHeight = computed(() => {
    return maxRows.value * cardHeight.value + 60 + 72;
  });

  const maxRows = computed(() => {
    return listData.value?.length ?? 0;
  });

  const currentData = computed(() => {
    let startIndex = Math.round((topPosition.value / maxHeight.value) * maxRows.value);
    startIndex = isNaN(startIndex) ? 0 : startIndex;
    const endIndex = startIndex + rowsInOneFrame.value;

    return arraySlice(listData.value, startIndex, endIndex);
  });

  //methods
  const getNumericValueFromCss = (cssValue: string) => {
    const strValues = cssValue.split('px');
    if (strValues.length) {
      return parseInt(strValues[0]);
    }
    return 0;
  };

  const observeScroll = (scrollBarRef: any) => {
    const scrollbar = scrollBarRef.$el as any;
    const psRailY = scrollbar?.getElementsByClassName('ps__rail-y');
    const style = window.getComputedStyle(psRailY[0]);
    topPosition.value = getNumericValueFromCss(style.top);
  };

  return {
    topPosition,
    wrapperStyle,
    rowStyle,
    observeScroll,
    currentData,
    perfectScrollbarOptions,
  };
};
